<template>
    <div>
        <div class="row">
            <div :class="colWidth">
                <table :class="tableClass">
                    <caption>Identification de l'employé(e)</caption>
                    <thead class="hidden">
                        <tr>
                            <th scope="col">{{this.$t('general.donneesEntree')}}</th>
                            <th scope="col">{{this.$t('general.valeur')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.anneeFiscale')}}</td>
                        <td :class='colRight'>{{dossier.periodeFiscale}}</td>
                    </tr>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.nom')}}</td>
                        <td :class='colRight'>{{dossier.nom}}</td>
                    </tr>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.prenom')}}</td>
                        <td :class='colRight'>{{dossier.prenom}}</td>
                    </tr>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.adresseRue')}}</td>
                        <td :class='colRight'>{{dossier.adresseRue}}</td>
                    </tr>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.adresseLocalite')}}</td>
                        <td :class='colRight'>{{dossier.adresseLocalite}}</td>
                    </tr>
                    <tr v-if="dossier.noCollaborateur">
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.numeroCollaborateur')}}</td>
                        <td :class='colRight'>{{dossier.noCollaborateur}}</td>
                    </tr>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.numeroAVS')}}</td>
                        <td :class='colRight'>{{dossier.numeroAVS}}</td>
                    </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <div class="row">
            <div :class="colWidth">
                <table :class="tableClass">
                    <caption>Synthèse de votre déclaration et barème correspondant</caption>
                    <thead class="hidden">
                        <tr>
                            <th scope="col">{{this.$t('general.donneesEntree')}}</th>
                            <th scope="col">{{this.$t('general.valeur')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.typeImposition')}}</td>
                        <td :class='colRight'>{{ typeResident }}</td>
                    </tr>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.tauxActivite')}}</td>
                        <td :class='colRight'>{{activite}}</td>
                    </tr>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.etatCivil')}}</td>
                        <td :class='colRight'>{{dossier.etatCivil.description}}</td>
                    </tr>
                    <!--Date changement etat civil-->
                    <tr v-if="dossier.dateChangementEtatCivil">
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.dateChangementEtatCivil')}}</td>
                        <td :class='colRight'>{{formatDateJJMMYYYY(dossier.dateChangementEtatCivil)}}</td>
                    </tr>
                    <tr>
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.enfantsACharge')}}</td>
                        <td :class='colRight'>{{dossier.hasEnfants ? $t('general.oui') : $t('general.non')}}</td>
                    </tr>
                    <tr v-if="dossier.hasEnfants">
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.dateNaissanceEnfants')}}</td>
                        <td :class='colRight'>{{dossier.datesNaissanceEnfants.map(e => formatDateJJMMYYYY(e.dateNaissance)).join(" - ")}}</td>
                    </tr>

                    <!--Vit en union libre-->
                    <tr v-if="dossier.hasEnfants && !dossier.isMarie">
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.unionLibre')}}</td>
                        <td :class='colRight'>{{dossier.isUnionLibre ? $t('general.oui') : $t('general.non')}}</td>
                    </tr>

                    <!--Garde alternée-->
                    <tr v-if="dossier.hasEnfants && !dossier.isMarie">
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.gardeAlternee')}}</td>
                        <td :class='colRight'>{{dossier.isGardeAlternee ? $t('general.oui') : $t('general.non')}}</td>
                    </tr>

                    <!--Conjoint fonctionnaire International -->
                    <tr v-if="dossier.isMarie">
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.conjointFonctionnaireInternational')}}</td>
                        <td :class='colRight'>{{fonctionnaireInternational}}</td>
                    </tr>
                    <!--Conjoint perçoit des revenus-->
                    <tr v-if="dossier.isMarie && !this.dossier.isConjointFonctionnaireInt">
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.conjointPercoitRevenu')}}</td>
                        <td :class='colRight'>{{conjointRevenu}}</td>
                    </tr>
                    <tr v-if="hasRemarques">
                        <td :class='colLeft'>{{$t('Bareme.etape2.champs.remarques')}}</td>
                        <td :class='colRight' class="text-wrap">
                            <p v-if="dossier.remarques[0]">{{dossier.remarques[0]}}</p>
                            <p v-if="dossier.remarques[1]">{{dossier.remarques[1]}}</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <p>&nbsp;</p>
    </div>
</template>

<script>

import { formatJacksonDateToDDMMYYYY } from '../../../../utils/DateUtils';

export default {
  name: 'section-donnees-formulaire',
  props: ['dossier', 'colLeft', 'colRight', 'tableClass', 'colWidth'],
  methods: {
    formatDateJJMMYYYY(date) {
      return formatJacksonDateToDDMMYYYY(date);
    },
  },
  computed: {
    activite() {
      return this.dossier.isRevenuUnSeulEmployeur ? this.$t('general.unSeulEmployeur') : `${this.$t('general.plusDunEmployeur')} - ${this.dossier.tauxGlobalActivite}%`;
    },
    conjointRevenu() {
      if (this.dossier.hasConjointRevenu) {
        return this.$t('general.oui') + this.dossier.sourceRevenu.map(e => e.label).join(', ');
      }
      return this.$t('general.non');
    },
    fonctionnaireInternational() {
      const fonctInt = this.dossier.isConjointFonctionnaireInt ? this.$t('general.oui') : this.$t('general.non');
      let bareme = '';
      if (this.dossier.isConjointFonctionnaireInt) {
        bareme = this.dossier.typeFonctInt.value === '0' ? this.$t('general.fonctionnaireListeBaremeB') : this.$t('general.fonctionnaireListeBaremeC');
      }
      return fonctInt + bareme;
    },
    hasRemarques() {
      return this.dossier.remarques !== null && this.dossier.remarques !== undefined
            && this.dossier.remarques.length > 0 && (this.dossier.remarques[0] !== '' || this.dossier.remarques[1] !== '');
    },
    typeResident() {
      let typeResident = this.dossier.typeResident.description;
      if (this.dossier.typeResident.value === 'S') {
        typeResident += ` - ${this.dossier.canton.label}`;
      }
      return typeResident;
    },
  },
};
</script>

<style scoped>
    .text-wrap {
        word-wrap: break-word;
        word-break: break-all;
    }
</style>
